// import router from '@/router';
import environment from './environment';

interface ItemType {
  children: [];
  link?: string;
  id?: number;
}
function getMenuId() {
  const menu = sessionStorage.getItem('menu') ? JSON.parse(sessionStorage.getItem('menu') || '') : [];
  let path = '';
  if (window.location.hash) { // vue hash模式
    const pathArr = window.location.hash.substr(1).split('?') || [];
    pathArr.forEach((item, key) => {
      if (key === 0) {
        path = item;
      }
    });
  } else {
    const pathArr = window.location.href.replace(window.location.origin, '').split('?') || [];
    pathArr.forEach((item, key) => {
      if (key === 0) {
        path = item;
      }
    });
  }
  let menuId: number| undefined = -1;
  menu.forEach((item: ItemType) => {
    item.children.forEach((jtem: ItemType) => {
      jtem.children.forEach((m: ItemType) => {
        if (m.link === path) {
          const { id } = m;
          menuId = id;
        }
      });
    });
  });
  return menuId < 0 ? environment.menuId : menuId;
}
export default getMenuId;
